var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBannerBackgroundIcon = function SvgBannerBackgroundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 292,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M290.359-30q28.754 4.8 36.724 32.508V179.5h-106.5V74.749H114.082V-30zM110.402 74.75v108.361h110.174v108.362q-93.666.904-187.295-1.806-25.074-8.604-31.215-34.315A4443 4443 0 0 1 .229 74.75z",
    clipRule: "evenodd"
  })));
};
export default SvgBannerBackgroundIcon;